export default "__VITE_ASSET__f7bbb6bc__"